import React, {useEffect, useState} from 'react';
import {useAuth0} from "@auth0/auth0-react";

export const useCheckRole = () => {
    const { user } = useAuth0();
    const [accessToAdmin, setAccessToAdmin] = useState(false);
    const [accessToBasicFlow, setAccessToBasicFlow] = useState(false);
    useEffect(()=>{
        const rolesKey = `${process.env.REACT_APP_JWT_CUSTOM_NAMESPACE}/roles`;
        const roles = user && user[rolesKey];
        if(roles) {
            setAccessToAdmin(roles.includes(process.env.REACT_APP_ALLOW_ADMIN_SECTION_ROLE));
            setAccessToBasicFlow(roles.includes(process.env.REACT_APP_ALLOW_BASIC_FLOW_SECTION_ROLE));
        }
    }, [user]);

    return {accessToAdmin, accessToBasicFlow};
}
